// Mock data for the People Hub "Home" tab. No backend exists yet — this file stands in for
// the future People Hub API responses so the UI can be built and demoed against realistic data.
// TODO: Replace each MOCK_* export with a real API call once the People Hub backend is available.
import {
  QueueItem,
  QueueBandMeta,
  OnboardingEmployee,
  TimeframeOption,
  LocationWorkloadSnapshot,
  RecentActivityRecord,
} from './types';

export const QUEUE_BANDS: QueueBandMeta[] = [
  { key: 'progress', title: 'In progress', copy: 'Resume saved work before starting another activity' },
  { key: 'overdue', title: 'Overdue', copy: 'Past the date the onboarding item was owed' },
  { key: 'upcoming', title: 'Upcoming', copy: 'Still ahead of the due date' },
];

export const MOCK_QUEUE_ITEMS: QueueItem[] = [
  // In progress (2)
  {
    id: 'q-1', employeeName: 'Maria Chen', employeeRole: 'Transport Load & Unload', type: 'Pulse Check',
    assignedTo: 'Amara Torres', canReassign: false, tags: [{ label: 'Repack Policy', tone: 'plain' }],
    band: 'progress', dueLabel: 'Saved draft',
  },
  {
    id: 'q-2', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Observation',
    assignedTo: 'Amara Torres', canReassign: false, band: 'progress', dueLabel: 'Saved draft',
  },

  // Overdue (9)
  {
    id: 'q-3', employeeName: 'Sofia Lopez', employeeRole: 'Repack', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'SRL Training', tone: 'plain' }],
    band: 'overdue', dueLabel: '23 days late',
  },
  {
    id: 'q-4', employeeName: 'David Wu', employeeRole: 'Chilled', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'PIT Training', tone: 'plain' }],
    band: 'overdue', dueLabel: '18 days late',
  },
  {
    id: 'q-5', employeeName: 'Nina Patel', employeeRole: 'Chilled', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 2', tone: 'phase' }, { label: 'Bulk Picking Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '15 days late',
  },
  {
    id: 'q-6', employeeName: 'Derrick King', employeeRole: 'Picker', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'Crossdock Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '12 days late',
  },
  {
    id: 'q-7', employeeName: 'Grace Kim', employeeRole: 'Layer Claw', type: 'Certification',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 2', tone: 'phase' }, { label: 'EHS Compliance', tone: 'plain' }],
    band: 'overdue', dueLabel: '9 days late',
  },
  {
    id: 'q-8', employeeName: 'John Ramirez', employeeRole: 'Layer Claw', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 3', tone: 'phase' }, { label: 'Inventory Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '7 days late',
  },
  {
    id: 'q-9', employeeName: 'Jamal Carter', employeeRole: 'Picker', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'Full Picking Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '5 days late',
  },
  {
    id: 'q-10', employeeName: 'Marcus Webb', employeeRole: 'Repack', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 2', tone: 'phase' }, { label: 'QC Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '3 days late',
  },
  {
    id: 'q-11', employeeName: 'Devon Brooks', employeeRole: 'Picker', type: 'Training',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'Putaway Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '1 day late',
  },

  // Upcoming (12)
  {
    id: 'q-12', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Pulse Check',
    assignedTo: 'Amara Torres', canReassign: true, band: 'upcoming', dueLabel: 'In 1 day',
  },
  {
    id: 'q-13', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Certification',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'EHS Compliance', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 4 days',
  },
  {
    id: 'q-14', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Certification',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 2', tone: 'phase' }, { label: 'SRL Certification', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 4 days',
  },
  {
    id: 'q-15', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Certification',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Week 2', tone: 'phase' }, { label: 'PIT Certification', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 4 days',
  },
  {
    id: 'q-16', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Milestone',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Milestone 1', tone: 'phase' }, { label: 'KPI ramp review', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 4 days',
  },
  {
    id: 'q-17', employeeName: 'Sofia Lopez', employeeRole: 'Repack', type: 'Milestone',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Milestone 2', tone: 'phase' }, { label: 'Cross-training and KPI review', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 26 days',
  },
  {
    id: 'q-18', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Milestone',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Milestone 2', tone: 'phase' }, { label: 'Cross-training and KPI review', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 32 days',
  },
  {
    id: 'q-19', employeeName: 'Devon Brooks', employeeRole: 'Picker', type: 'Observation',
    assignedTo: 'Amara Torres', canReassign: true, band: 'upcoming', dueLabel: 'In 50 days',
  },
  {
    id: 'q-20', employeeName: 'John Ramirez', employeeRole: 'Layer Claw', type: 'Observation',
    assignedTo: 'Amara Torres', canReassign: true,
    tags: [{ label: 'Gap Time', tone: 'metric' }], band: 'upcoming', dueLabel: 'In 50 days',
  },
  {
    id: 'q-21', employeeName: 'Sofia Lopez', employeeRole: 'Repack', type: 'Observation',
    assignedTo: 'Amara Torres', canReassign: true, band: 'upcoming', dueLabel: 'In 50 days',
  },
  {
    id: 'q-22', employeeName: 'Sofia Lopez', employeeRole: 'Repack', type: 'Milestone',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Milestone 3', tone: 'phase' }, { label: 'Review and graduation', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 54 days',
  },
  {
    id: 'q-23', employeeName: 'Priya Nair', employeeRole: 'Picker', type: 'Milestone',
    assignedTo: 'Amara Torres', canReassign: false,
    tags: [{ label: 'Milestone 3', tone: 'phase' }, { label: 'Review and graduation', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 60 days',
  },

  // Other leaders' rows: only visible under "All Tasks" scope, not "My Tasks" (Amara Torres).
  {
    id: 'q-24', employeeName: 'Aaliyah Chen', employeeRole: 'Chilled', type: 'Pulse Check',
    assignedTo: 'Jordan Blake', canReassign: false, band: 'progress', dueLabel: 'Saved draft',
  },
  {
    id: 'q-25', employeeName: 'Omar Petit', employeeRole: 'Repack', type: 'Observation',
    assignedTo: 'Renee Cho', canReassign: false, band: 'progress', dueLabel: 'Saved draft',
  },
  {
    id: 'q-26', employeeName: 'Miguel Torres', employeeRole: 'Picker', type: 'Training',
    assignedTo: 'Jordan Blake', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'Receiving Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '11 days late',
  },
  {
    id: 'q-27', employeeName: 'Hannah Reyes', employeeRole: 'Layer Claw', type: 'Certification',
    assignedTo: 'Renee Cho', canReassign: false,
    tags: [{ label: 'Week 2', tone: 'phase' }, { label: 'EHS Compliance', tone: 'plain' }],
    band: 'overdue', dueLabel: '6 days late',
  },
  {
    id: 'q-28', employeeName: 'Aaliyah Chen', employeeRole: 'Chilled', type: 'Training',
    assignedTo: 'Jordan Blake', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'Bulk Loader Training Guide', tone: 'plain' }],
    band: 'overdue', dueLabel: '2 days late',
  },
  {
    id: 'q-29', employeeName: 'Omar Petit', employeeRole: 'Repack', type: 'Pulse Check',
    assignedTo: 'Renee Cho', canReassign: true, band: 'upcoming', dueLabel: 'In 2 days',
  },
  {
    id: 'q-30', employeeName: 'Miguel Torres', employeeRole: 'Picker', type: 'Certification',
    assignedTo: 'Jordan Blake', canReassign: false,
    tags: [{ label: 'Week 1', tone: 'phase' }, { label: 'PIT Certification', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 5 days',
  },
  {
    id: 'q-31', employeeName: 'Hannah Reyes', employeeRole: 'Layer Claw', type: 'Milestone',
    assignedTo: 'Renee Cho', canReassign: false,
    tags: [{ label: 'Milestone 1', tone: 'phase' }, { label: 'KPI ramp review', tone: 'plain' }],
    band: 'upcoming', dueLabel: 'In 9 days',
  },
];

export const MOCK_ONBOARDING_EMPLOYEES: OnboardingEmployee[] = [
  {
    id: 'nh-1', name: 'Priya Nair', role: 'Picker', dayLabel: 'day 25 of 84',
    badgeLabel: 'At risk', badgeTone: 'atRisk',
    steps: [
      { key: 'W1', status: 'behind', completed: 1, total: 5 },
      { key: 'W2', status: 'behind', completed: 0, total: 3 },
      { key: 'W3', status: 'behind', completed: 0, total: 1 },
      { key: 'M1', status: 'current', completed: 0, total: 1 },
      { key: 'M2', status: 'pending', completed: 0, total: 1 },
      { key: 'M3', status: 'pending', completed: 0, total: 1 },
    ],
  },
  {
    id: 'nh-2', name: 'Nina Patel', role: 'Chilled', dayLabel: 'day 75 of 84',
    badgeLabel: '4 late', badgeTone: 'late',
    steps: [
      { key: 'W1', status: 'behind', completed: 3, total: 5 },
      { key: 'W2', status: 'behind', completed: 2, total: 3 },
      { key: 'W3', status: 'complete', completed: 1, total: 1 },
      { key: 'M1', status: 'complete', completed: 1, total: 1 },
      { key: 'M2', status: 'behind', completed: 0, total: 1 },
      { key: 'M3', status: 'current', completed: 0, total: 1 },
    ],
  },
  {
    id: 'nh-3', name: 'Sofia Lopez', role: 'Repack', dayLabel: 'day 31 of 84',
    badgeLabel: '4 late', badgeTone: 'late',
    steps: [
      { key: 'W1', status: 'behind', completed: 3, total: 5 },
      { key: 'W2', status: 'behind', completed: 2, total: 3 },
      { key: 'W3', status: 'complete', completed: 1, total: 1 },
      { key: 'M1', status: 'behind', completed: 0, total: 1 },
      { key: 'M2', status: 'current', completed: 0, total: 1 },
      { key: 'M3', status: 'pending', completed: 0, total: 1 },
    ],
  },
  {
    id: 'nh-4', name: 'Derrick King', role: 'Picker', dayLabel: 'day 23 of 84',
    badgeLabel: '4 late', badgeTone: 'late',
    steps: [
      { key: 'W1', status: 'behind', completed: 3, total: 5 },
      { key: 'W2', status: 'behind', completed: 2, total: 3 },
      { key: 'W3', status: 'pending', completed: 0, total: 1 },
      { key: 'M1', status: 'current', completed: 1, total: 1 },
      { key: 'M2', status: 'pending', completed: 0, total: 1 },
      { key: 'M3', status: 'pending', completed: 0, total: 1 },
    ],
  },
];

export const WORKLOAD_TIMEFRAMES: TimeframeOption[] = [
  { id: 'cw', label: 'CW' },
  { id: 'period', label: 'Period' },
  { id: 'quarter', label: 'Quarter' },
  { id: 'all', label: 'All Open' },
];

const SITE_NAME = 'Riverside DC';

// Keyed "view-timeframe" snapshots. Only site/cw is exact to the reference UI; the rest are
// plausible mocked variations of the same shape until the real workload API exists.
const WORKLOAD_SNAPSHOTS: Record<string, LocationWorkloadSnapshot> = {
  'site-cw': {
    dueCount: 27,
    leadCopy: `200 of 227 obligations owed through the end of the current week are complete at ${SITE_NAME}. 27 are still open, 17 of them overdue.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 0, upcomingCount: 7, doneCount: 152, totalCount: 159, percent: 96 },
      { key: 'Observation', label: 'Observations', overdueCount: 0, upcomingCount: 3, doneCount: 25, totalCount: 28, percent: 89 },
      { key: 'Training', label: 'Training', overdueCount: 15, upcomingCount: 0, doneCount: 10, totalCount: 25, percent: 40 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 0, doneCount: 10, totalCount: 10, percent: 100 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 2, upcomingCount: 0, doneCount: 3, totalCount: 5, percent: 60 },
    ],
  },
  'site-period': {
    dueCount: 41,
    leadCopy: `214 of 255 obligations owed through the end of the current period are complete at ${SITE_NAME}. 41 are still open, 19 of them overdue.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 1, upcomingCount: 12, doneCount: 158, totalCount: 171, percent: 92 },
      { key: 'Observation', label: 'Observations', overdueCount: 0, upcomingCount: 6, doneCount: 27, totalCount: 33, percent: 82 },
      { key: 'Training', label: 'Training', overdueCount: 16, upcomingCount: 3, doneCount: 12, totalCount: 31, percent: 39 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 2, doneCount: 11, totalCount: 13, percent: 85 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 2, upcomingCount: 1, doneCount: 4, totalCount: 7, percent: 57 },
    ],
  },
  'site-quarter': {
    dueCount: 58,
    leadCopy: `241 of 299 obligations owed through the end of the current quarter are complete at ${SITE_NAME}. 58 are still open, 22 of them overdue.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 2, upcomingCount: 20, doneCount: 165, totalCount: 187, percent: 88 },
      { key: 'Observation', label: 'Observations', overdueCount: 1, upcomingCount: 10, doneCount: 30, totalCount: 41, percent: 73 },
      { key: 'Training', label: 'Training', overdueCount: 17, upcomingCount: 6, doneCount: 14, totalCount: 37, percent: 38 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 4, doneCount: 12, totalCount: 16, percent: 75 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 2, upcomingCount: 2, doneCount: 4, totalCount: 8, percent: 50 },
    ],
  },
  'site-all': {
    dueCount: 64,
    leadCopy: `312 of 376 obligations currently owed are complete at ${SITE_NAME}. 64 remain open across every horizon.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 2, upcomingCount: 24, doneCount: 205, totalCount: 231, percent: 89 },
      { key: 'Observation', label: 'Observations', overdueCount: 1, upcomingCount: 12, doneCount: 38, totalCount: 51, percent: 75 },
      { key: 'Training', label: 'Training', overdueCount: 17, upcomingCount: 8, doneCount: 18, totalCount: 43, percent: 42 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 4, doneCount: 14, totalCount: 18, percent: 78 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 2, upcomingCount: 3, doneCount: 5, totalCount: 10, percent: 50 },
    ],
  },
  'leader-cw': {
    dueCount: 9,
    leadCopy: `62 of 71 obligations you own through the end of the current week are complete. 9 are still open, 5 of them overdue.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 0, upcomingCount: 2, doneCount: 48, totalCount: 50, percent: 96 },
      { key: 'Observation', label: 'Observations', overdueCount: 0, upcomingCount: 1, doneCount: 8, totalCount: 9, percent: 89 },
      { key: 'Training', label: 'Training', overdueCount: 5, upcomingCount: 0, doneCount: 3, totalCount: 8, percent: 38 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 0, doneCount: 2, totalCount: 2, percent: 100 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 0, upcomingCount: 0, doneCount: 1, totalCount: 2, percent: 50 },
    ],
  },
  'leader-period': {
    dueCount: 13,
    leadCopy: `69 of 82 obligations you own through the end of the current period are complete. 13 are still open, 6 of them overdue.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 0, upcomingCount: 3, doneCount: 51, totalCount: 54, percent: 94 },
      { key: 'Observation', label: 'Observations', overdueCount: 0, upcomingCount: 2, doneCount: 9, totalCount: 11, percent: 82 },
      { key: 'Training', label: 'Training', overdueCount: 6, upcomingCount: 1, doneCount: 4, totalCount: 11, percent: 36 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 1, doneCount: 3, totalCount: 4, percent: 75 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 0, upcomingCount: 0, doneCount: 2, totalCount: 3, percent: 67 },
    ],
  },
  'leader-quarter': {
    dueCount: 18,
    leadCopy: `77 of 95 obligations you own through the end of the current quarter are complete. 18 are still open, 7 of them overdue.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 1, upcomingCount: 5, doneCount: 53, totalCount: 59, percent: 90 },
      { key: 'Observation', label: 'Observations', overdueCount: 0, upcomingCount: 3, doneCount: 10, totalCount: 13, percent: 77 },
      { key: 'Training', label: 'Training', overdueCount: 6, upcomingCount: 2, doneCount: 5, totalCount: 13, percent: 38 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 1, doneCount: 4, totalCount: 5, percent: 80 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 0, upcomingCount: 1, doneCount: 2, totalCount: 4, percent: 50 },
    ],
  },
  'leader-all': {
    dueCount: 21,
    leadCopy: `98 of 119 obligations you currently own are complete. 21 remain open across every horizon.`,
    trackers: [
      { key: 'Pulse Check', label: 'Pulse Checks', overdueCount: 1, upcomingCount: 6, doneCount: 65, totalCount: 72, percent: 90 },
      { key: 'Observation', label: 'Observations', overdueCount: 0, upcomingCount: 4, doneCount: 12, totalCount: 16, percent: 75 },
      { key: 'Training', label: 'Training', overdueCount: 6, upcomingCount: 3, doneCount: 6, totalCount: 15, percent: 40 },
      { key: 'Certification', label: 'Certifications', overdueCount: 0, upcomingCount: 1, doneCount: 4, totalCount: 5, percent: 80 },
      { key: 'Milestone', label: 'Milestones', overdueCount: 0, upcomingCount: 1, doneCount: 2, totalCount: 4, percent: 50 },
    ],
  },
};

export const getMockWorkloadSnapshot = (view: 'site' | 'leader', timeframe: string): LocationWorkloadSnapshot =>
  WORKLOAD_SNAPSHOTS[`${view}-${timeframe}`] ?? WORKLOAD_SNAPSHOTS['site-cw'];

export const MOCK_RECENT_ACTIVITY: RecentActivityRecord[] = [
  { id: 'ra-1', employeeName: 'Grace Kim', type: 'Pulse Check', status: 'Completed', date: '07/26' },
  { id: 'ra-2', employeeName: 'David Wu', type: 'Observation', status: 'In Progress', date: '07/25' },
  { id: 'ra-3', employeeName: 'Nina Patel', type: 'Observation', status: 'In Progress', date: '07/25' },
  { id: 'ra-4', employeeName: 'Nina Patel', type: 'Milestone', status: 'Completed', date: '07/25' },
  { id: 'ra-5', employeeName: 'John Ramirez', type: 'Pulse Check', status: 'Completed', date: '07/24' },
  { id: 'ra-6', employeeName: 'Maria Chen', type: 'Observation', status: 'Completed', date: '07/24' },
  { id: 'ra-7', employeeName: 'Jamal Carter', type: 'Milestone', status: 'In Progress', date: '07/24' },
  { id: 'ra-8', employeeName: 'Priya Nair', type: 'Observation', status: 'In Progress', date: '07/23' },
  { id: 'ra-9', employeeName: 'Sofia Lopez', type: 'Certification', status: 'Completed', date: '07/23' },
  { id: 'ra-10', employeeName: 'Derrick King', type: 'Observation', status: 'Completed', date: '07/22' },
];
